module.exports = __webpack_public_path__ + "img/bni.126e900d.png";